module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pager"
  }, [_c('div', {}, [_c('h2', {
    staticClass: "sp-app-default-color",
    staticStyle: {
      "font-size": "4em"
    }
  }, [_vm._v("WEBnSHOP")]), _vm._v(" "), _c('div', {
    staticClass: "page-top-header sticky-tab",
    attrs: {
      "id": "pageStickyHeader"
    }
  }, [_c('div', {
    staticClass: "tab-slide-md"
  }, [_c('ul', [_c('li', [_c('a', {
    staticClass: "tab-menu-link",
    attrs: {
      "id": "welcomeView"
    },
    on: {
      "click": function($event) {
        _vm.setMenuComponent('welcomeView')
      }
    }
  }, [_vm._v("Welcome")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tab-menu-link",
    attrs: {
      "id": "aboutView"
    },
    on: {
      "click": function($event) {
        _vm.setMenuComponent('aboutView')
      }
    }
  }, [_vm._v("About")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tab-menu-link",
    attrs: {
      "id": "categoriesView"
    },
    on: {
      "click": function($event) {
        _vm.setMenuComponent('categoriesView')
      }
    }
  }, [_vm._v("Categories")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tab-menu-link",
    attrs: {
      "id": "productsView"
    },
    on: {
      "click": function($event) {
        _vm.setMenuComponent('productsView')
      }
    }
  }, [_vm._v("Products")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tab-menu-link",
    attrs: {
      "id": "reviewsView"
    },
    on: {
      "click": function($event) {
        _vm.setMenuComponent('reviewsView')
      }
    }
  }, [_vm._v("Reviews")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tab-menu-link",
    attrs: {
      "id": "newsView"
    },
    on: {
      "click": function($event) {
        _vm.setMenuComponent('newsView')
      }
    }
  }, [_vm._v("News")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tab-menu-link",
    attrs: {
      "id": "eventsView"
    },
    on: {
      "click": function($event) {
        _vm.setMenuComponent('eventsView')
      }
    }
  }, [_vm._v("Events")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tab-menu-link",
    attrs: {
      "id": "dealsView"
    },
    on: {
      "click": function($event) {
        _vm.setMenuComponent('dealsView')
      }
    }
  }, [_vm._v("Deals")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tab-menu-link",
    attrs: {
      "id": "contactView"
    },
    on: {
      "click": function($event) {
        _vm.setMenuComponent('contactView')
      }
    }
  }, [_vm._v("Contact")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tab-menu-link",
    attrs: {
      "id": "chatView"
    },
    on: {
      "click": function($event) {
        _vm.setMenuComponent('chatView')
      }
    }
  }, [_vm._v("Chat")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row row-after-stick",
    staticStyle: {
      "padding": "0 0.5em",
      "margin-bottom": "5em"
    }
  }, [_c('div', _vm._l((_vm.products), function(product, index) {
    return _c('div', {
      staticClass: "card col-xs-6 card-col-2",
      staticStyle: {
        "margin-bottom": "0.8em"
      }
    }, [_c('a', {
      staticStyle: {
        "text-decoration": "none",
        "color": "inherit"
      },
      attrs: {
        "href": '/appwedeliver/' + product.product_business_ownername + '/' + product.product_url_name
      }
    }, [_c('div', {
      staticClass: "card-col-img",
      staticStyle: {
        "margin-bottom": "0.8em",
        "border-left": "#f5f5f5 solid 0.35em",
        "border-radius": "4px"
      }
    }, [(product.product_images[0]) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-col-details",
      staticStyle: {
        "display": "block"
      }
    }, [_c('p', {
      staticStyle: {
        "font-size": "13px",
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(product.product_name)), _c('br'), _vm._v(" "), (product.product_items[0]) ? _c('span', {
      staticClass: "sp-app-default-color"
    }, [_vm._v("₦" + _vm._s(product.product_items[0].product_item_price_f))]) : _vm._e()]), _vm._v(" "), _vm._m(0, true)])])])
  })), _vm._v(" "), (_vm.menu_view.aboutView) ? _c('div', [_vm._v("\r\n          About"), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "btn sp-button-1 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": _vm.followSellpoint
    }
  }, [_vm._v("Follow " + _vm._s(_vm.sellpoint.business_username))])]) : _vm._e(), _vm._v(" "), (_vm.menu_view.categoriesView) ? _c('div', [_vm._v("\r\n          Categories\r\n        ")]) : _vm._e(), _vm._v(" "), (_vm.menu_view.productsView) ? _c('div', [_vm._v("\r\n          Products\r\n        ")]) : _vm._e(), _vm._v(" "), (_vm.menu_view.reviewsView) ? _c('div', [_vm._v("\r\n          Reviews\r\n        ")]) : _vm._e(), _vm._v(" "), (_vm.menu_view.newsView) ? _c('div', {
    staticStyle: {
      "padding": "0 2em"
    }
  }, [_vm._v("\r\n          News\r\n          \r\n        ")]) : _vm._e(), _vm._v(" "), (_vm.menu_view.eventsView) ? _c('div', [_vm._v("\r\n          Events\r\n        ")]) : _vm._e(), _vm._v(" "), (_vm.menu_view.dealsView) ? _c('div', [_vm._v("\r\n          Deals\r\n        ")]) : _vm._e(), _vm._v(" "), (_vm.menu_view.contactView) ? _c('div', [_vm._v("\r\n          Contact\r\n        ")]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-arm-alt-bottom",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "card-analytics"
  }, [_c('ul', [_c('li', [_c('i', {
    staticClass: "fa fa-tag"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-star"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-shopping-bag"
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d2a0cc0"}!./src/pages/AppWebnShop/Points/template.html
// module id = 413
// module chunks = 0